import request from '@/config/axios'

// 客户面谈 VO
export interface InterviewVO {
  id: number // 编号
  interviewTime: Date // 面谈时间
  category: number // 分类（字典 crm_interview_category）
  areaId: number // 所在地（地区编号）
  areaName?: string // 所在地名称
  customerId: number // 客户编号
  customerName?: string // 客户名称
  salesUserId: number // 销售（用户编号）
  salesUserName?: string // 销售名字
  participantUserIds: number[] // 参与人员（用户编号数组）
  participantUserNames?: string // 参与人员名字，顿号分隔
  prepare: string // 需要准备
  remark: string // 备注
  creator?: string
  creatorName?: string
  createTime?: Date
}

// 客户面谈 API
export const InterviewApi = {
  // 查询客户面谈分页
  getInterviewPage: async (params: any) => {
    return await request.get({ url: `/crm/interview/page`, params })
  },

  // 查询客户面谈详情
  getInterview: async (id: number) => {
    return await request.get({ url: `/crm/interview/get?id=` + id })
  },

  // 新增客户面谈
  createInterview: async (data: InterviewVO) => {
    return await request.post({ url: `/crm/interview/create`, data })
  },

  // 修改客户面谈
  updateInterview: async (data: InterviewVO) => {
    return await request.put({ url: `/crm/interview/update`, data })
  },

  // 删除客户面谈
  deleteInterview: async (id: number) => {
    return await request.delete({ url: `/crm/interview/delete?id=` + id })
  },

  // 导出客户面谈
  exportInterview: async (params: any) => {
    return await request.download({ url: `/crm/interview/export`, params })
  }
}
